import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect, useRef } from 'react';
import { TextField } from "../TextField";
import mergeRefs from 'react-merge-refs';
import { useRegisterMenuItem } from "./useRegisterMenuItem";
import styled from 'styled-components';
import { theme } from "../../theme";
import { wrapEvent } from "../../utils/wrap-event";
/**
 * MenuTextField
 *
 * A component for utilizing a TextField within a Menu. This
 * offers prescribed behavior for keyboard navigation.
 */

export var MenuTextField = React.forwardRef(function (_ref, forwardedRef) {
  var onKeyDownProp = _ref.onKeyDown,
      other = _objectWithoutProperties(_ref, ["onKeyDown"]);

  var ref = useRef(null);

  var _useRegisterMenuItem = useRegisterMenuItem(ref),
      isSelected = _useRegisterMenuItem.isSelected,
      select = _useRegisterMenuItem.select;

  var inputRef = useRef(null);
  /**
   * When a user navigates to the TextField via keyboard,
   * manually focus the input.
   */

  useEffect(function () {
    if (isSelected) {
      inputRef.current.focus();
    }
  }, [isSelected]);
  /**
   * Prevent Menu keyboard navigation from taking over
   * when using arrow keys within a TextField.
   */

  function onKeyDown(e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Escape' && !(!inputRef.current.value && (e.key === 'ArrowLeft' || e.key === 'ArrowRight'))) {
      e.stopPropagation();
    }
  }

  return /*#__PURE__*/React.createElement(Container, {
    ref: ref
  }, /*#__PURE__*/React.createElement(TextField, _extends({
    ref: mergeRefs([inputRef, forwardedRef]),
    onKeyDown: wrapEvent(onKeyDown, onKeyDownProp),
    onFocus: select
  }, other)));
});
var Container = styled.div.withConfig({
  displayName: "MenuTextField__Container",
  componentId: "vapor__sc-1oyiamw-0"
})(["padding:", " ", ";"], theme.spaces[2], theme.spaces[8]);